var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFailure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60 120C93.1371 120 120 93.1371 120 60C120 26.8629 93.1371 0 60 0C26.8629 0 0 26.8629 0 60C0 93.1371 26.8629 120 60 120Z",
    fill: "#FF3441",
    fillOpacity: 0.15
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9998 117.397C90.2308 117.397 114.738 92.89 114.738 62.659C114.738 32.428 90.2308 7.9209 59.9998 7.9209C29.7688 7.9209 5.26172 32.428 5.26172 62.659C5.26172 92.89 29.7688 117.397 59.9998 117.397Z",
    fill: "#FF3441"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M59.9998 109.814C46.1513 109.812 32.8183 104.56 22.6884 95.1175C12.5585 85.6748 6.38482 72.743 5.41176 58.9287C5.32303 60.203 5.26172 61.4849 5.26172 62.7819C5.26172 77.2993 11.0288 91.2221 21.2942 101.488C31.5595 111.753 45.4823 117.52 59.9998 117.52C74.5172 117.52 88.4401 111.753 98.7054 101.488C108.971 91.2221 114.738 77.2993 114.738 62.7819C114.738 61.4849 114.677 60.203 114.588 58.9287C113.615 72.743 107.441 85.6748 97.3112 95.1175C87.1813 104.56 73.8483 109.812 59.9998 109.814Z",
    fill: "#231F20"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M80 40L40 80M40 40L80 80",
    stroke: "white",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailure);
export default __webpack_public_path__ + "static/media/failure.7451dc14b43eda8e71fa5bc63044de4c.svg";
export { ForwardRef as ReactComponent };